import React from 'react';
import { cn } from '../../utils/cn';

const Tooltip = ({ content, children, align = 'center', placement = 'top', size = 'sm', className }) => {
  const sizeClass = size === 'md'
    ? 'max-w-sm px-3.5 py-2.5 text-sm'
    : 'max-w-xs px-3 py-2 text-xs';
  const alignClass = {
    center: 'left-1/2 -translate-x-1/2',
    start: 'left-0',
    end: 'right-0',
  }[align] || 'left-1/2 -translate-x-1/2';
  const placementClass = placement === 'bottom'
    ? 'top-full mt-2'
    : 'bottom-full mb-2';

  return (
    <span className={cn('relative inline-flex group/tooltip', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute z-50 w-max rounded-md border border-border bg-popover leading-relaxed text-popover-foreground shadow-elevation-md',
          placementClass,
          sizeClass,
          'opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible group-focus-within/tooltip:opacity-100 group-focus-within/tooltip:visible transition-opacity',
          alignClass
        )}
      >
        {content}
      </span>
    </span>
  );
};

export default Tooltip;
